import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import React from 'react'
import BootstrapControllerUI from './components/BootstrapControllerUI'
export { BootstrapController } from './controller/bootstrap-controller'
export { Stack } from './clients/web-client'

if (document.getElementById('root'))
  ReactDOM.render(<BootstrapControllerUI />, document.getElementById('root'))
